const timings = [
  { season: "Spring (Feb–May)", icon: "ri-seedling-line", risk: "High", desc: "PCS orders frequently arrive in spring for summer reporting dates. Military families with 30 days' notice need expedited processing immediately. Apply as soon as orders arrive." },
  { season: "Summer (Jun–Aug)", icon: "ri-sun-line", risk: "High", desc: "Peak vacation season. Casino executives travel to international gaming conferences. Barksdale families heading to overseas assignments need passports processed in days, not weeks." },
  { season: "Fall (Sep–Nov)", icon: "ri-leaf-line", risk: "Medium", desc: "Gaming industry conference season picks up. Medical professionals travel to CME events in Europe. Apply 4–6 weeks before departure for reliable delivery." },
  { season: "Winter (Dec–Jan)", icon: "ri-snowflake-line", risk: "Medium", desc: "Holiday international travel and New Year's cruises from New Orleans. Military rotations resume in January. Apply by November for holiday departures." },
];

export default function BossierCityTravelTimingSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Best Time to Apply</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            When Bossier City Travelers Apply for Passports
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Knowing when demand peaks helps you avoid delays. Here is what we see from Bossier City and Bossier Parish travelers throughout the year.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {timings.map((t, i) => (
            <div key={i} className="bg-white rounded-lg border border-gray-200 p-6 flex flex-col hover:border-[#F6C344] transition-all">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className={`${t.icon} text-[#1A365D] text-lg`}></i>
                </div>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm leading-snug">{t.season}</p>
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${t.risk === "High" ? "bg-red-100 text-red-600" : "bg-amber-100 text-amber-700"}`}>{t.risk} Demand</span>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">{t.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">
            Check My Processing Options <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}